import axios from 'axios';

const authProxyUrl = import.meta.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const authorizeUrl = import.meta.env.REACT_APP_OAUTH_AUTHORIZE_URL;

export const getToken = async (code) => {
  try {
    const response = await axios.post(`${authProxyUrl}/auth/token`, {
      code,
      redirect_uri: window.location.origin
    });
    
    // Armazenar o token no localStorage
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
    }
    
    return response.data.access_token;
  } catch (error) {
    console.error('Erro ao obter token', error);
    throw error;
  }
};

export const getUserData = async (token) => {
  try {
    const response = await axios.get(`${authProxyUrl}/auth/user-data`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = response.data;
    if (data && data.administrado === true) {
      return data;
    }
    const notAdminError = new Error('Você não é administrador do sistema. Esse serviço só pode ser configurado por administradores.');
    notAdminError.isNotAdmin = true;
    throw notAdminError;
  } catch (error) {
    console.error('Erro ao obter dados do usuário', error);
    throw error;
  }
};

export const getLoginUrl = () => {
  const clientId = import.meta.env.REACT_APP_CLIENT_ID;
  const redirectUri = window.location.origin;
  
  return `${authorizeUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code`;
};

export const logout = () => {
  localStorage.removeItem('access_token');
  // Redirecionar para a página de login ou home
  window.location.href = '/';
};